import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 'AccountNumber',
      name: i18n.t('agenda.account_number')
    },
    {
      id: 'IBAN',
      name: i18n.t('invoices.invoices_issuing.iban')
    },
  ]
}

export function TIPOS_CUENTA (state) {
  return configHelper.getConfig(state, 'TIPOS_CUENTA', GenerateConfig)
}
